$(document).ready(function () {

  let $lastFocusedElementBeforeModal;

  // ── Scrollbar-shift fix ──────────────────────────────────────────────────
  // Only fixed/sticky elements need explicit padding-right compensation —
  // they are positioned relative to the viewport, not the body's content box.
  //
  // The announcement bar section is in NORMAL FLOW: the body's own
  // padding-right already compensates it. Adding padding-right to it too
  // would double-compensate, narrowing it by 2× the scrollbar width and
  // shifting the centered text to the left. So it is intentionally excluded.

  const STICKY_SELECTORS = [
    'sticky-header',               // Dawn's main nav custom element
    '.header-wrapper',             // fallback class inside sticky-header
    '.shopify-section-header-sticky'
  ];

  function lockScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Lock the body — this compensates all normal-flow children automatically
    $('body').css({ overflow: 'hidden', paddingRight: scrollbarWidth + 'px' });

    // Compensate fixed/sticky bars that use viewport width, not body width
    STICKY_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.dataset.modalPrPrev = el.style.paddingRight || '';
        el.style.paddingRight = scrollbarWidth + 'px';
      });
    });
  }

  function unlockScroll() {
    $('body').css({ overflow: '', paddingRight: '' });

    STICKY_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.paddingRight = el.dataset.modalPrPrev || '';
        delete el.dataset.modalPrPrev;
      });
    });
  }
  // ────────────────────────────────────────────────────────────────────────

  function openModal(modalId) {
    const $modal = $(modalId);
    if (!$modal.length) {
      console.error('Modal not found:', modalId);
      return;
    }

    $lastFocusedElementBeforeModal = $(document.activeElement);
    const $overlay = $modal.find('.announcement-lightbox-overlay');

    lockScroll();

    $modal.addClass('is-visible').attr('aria-hidden', 'false');
    $overlay.css({ display: 'block', opacity: 1 });
    $modal.focus();

    // Attach close events for this modal instance
    $modal.find('.announcement-lightbox-close-button').on('click.modalEvents', function () {
      closeModal(modalId);
    });
    $overlay.on('click.modalEvents', function () {
      closeModal(modalId);
    });
  }

  function closeModal(modalId) {
    const $modal = $(modalId);
    const $overlay = $modal.find('.announcement-lightbox-overlay');

    $modal.removeClass('is-visible').attr('aria-hidden', 'true');
    $overlay.css({ display: 'none', opacity: 0 });

    unlockScroll();

    if ($lastFocusedElementBeforeModal && $lastFocusedElementBeforeModal.length) {
      $lastFocusedElementBeforeModal.focus();
    }

    // Clean up to prevent duplicate bindings on re-open
    $modal.find('.announcement-lightbox-close-button, .announcement-lightbox-overlay').off('.modalEvents');
  }

  // Main trigger
  $('.js-modal-trigger').on('click', function (e) {
    e.preventDefault();
    const modalIdToOpen = '#' + $(this).data('modal-id');
    openModal(modalIdToOpen);
  });

  // Keyboard: Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $('.announcement-lightbox-modal.is-visible').length) {
      const visibleModalId = '#' + $('.announcement-lightbox-modal.is-visible').attr('id');
      closeModal(visibleModalId);
    }
  });

});
